module.exports = __webpack_public_path__ + "static/media/main-hatching-success.58bf27e0.png";